import React from "react";
import { CheckCircle2, Circle } from "lucide-react";

const StepFormContainer = ({
  currentStep,
  totalSteps,
  stepTitles = [],
  children,
  onStepChange,
  showProgress = true,
}) => {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50">
      <div className="px-3 py-3 mx-auto max-w-8xl sm:px-4 sm:py-4 lg:px-6 lg:py-5">
        {/* Progress Indicator */}
        {showProgress && totalSteps > 1 && (
          <div className="mb-6">
            <div className="p-4 bg-white rounded-xl border border-gray-100 shadow-sm sm:rounded-2xl">
              <div className="flex justify-between items-center">
                {steps.map((step, index) => (
                  <React.Fragment key={step}>
                    <div className="flex flex-col items-center flex-1">
                      <div className="relative flex items-center">
                        <div
                          className={`flex justify-center items-center w-10 h-10 rounded-full border-2 transition-all duration-300 ${
                            step < currentStep
                              ? "bg-green-500 border-green-500 text-white"
                              : step === currentStep
                              ? "bg-blue-600 border-blue-600 text-white shadow-lg scale-110"
                              : "bg-white border-gray-300 text-gray-400"
                          }`}
                        >
                          {step < currentStep ? (
                            <CheckCircle2 className="w-5 h-5" />
                          ) : (
                            <Circle className="w-5 h-5" />
                          )}
                        </div>
                        {/* {step === currentStep && (
                          <div className="absolute -bottom-6 left-1/2 -translate-x-1/2">
                            <div className="px-2 py-1 text-xs font-semibold text-blue-600 bg-blue-50 rounded-lg whitespace-nowrap">
                              Step {step}
                            </div>
                          </div>
                        )} */}
                      </div>
                      {stepTitles[index] && (
                        <div
                          className={`mt-2 text-xs font-medium text-center transition-colors ${
                            step <= currentStep
                              ? "text-gray-900"
                              : "text-gray-400"
                          }`}
                        >
                          {stepTitles[index]}
                        </div>
                      )}
                    </div>
                    {index < steps.length - 1 && (
                      <div
                        className={`flex-1 h-0.5 mx-2 transition-all duration-300 ${
                          step < currentStep ? "bg-green-500" : "bg-gray-200"
                        }`}
                      />
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Step Content */}
        <div className="animate-in fade-in-0 slide-in-from-bottom-4 duration-300">
          {children}
        </div>
      </div>
    </div>
  );
};

export default StepFormContainer;
